import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../Lib/Cn"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap sahi-radius text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none   disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-sahi-primary-color text-primary-foreground hover:bg-primary-foreground hover:text-sahi-primary-color border border-transparent hover:border-sahi-primary-color",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border sahi-radius border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-white sahi-radius text-sahi-primary-color border border-sahi-primary-color hover:text-primary-foreground hover:bg-sahi-primary-color",
        sahiRed: "bg-sahi-red text-white border border-transparent hover:bg-sahi-red hover:brightness-110 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 transition-all duration-200 ease-in-out",
        sahiRedOutline: "bg-white text-sahi-red border border-sahi-red hover:bg-sahi-red hover:text-white transition-all duration-200 ease-in-out",
        sahiGreen: "bg-sahi-green text-white border  border-transparent hover:bg-sahi-green hover:brightness-110  hover:shadow-md  hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 transition-all  duration-200  ease-in-out",
        sahiDarkBlue: "bg-sahi-dark-blue text-white border  border-transparent hover:bg-sahi-dark-blue hover:brightness-110  hover:shadow-md  hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 transition-all  duration-200  ease-in-out",
        ghost: "",
        link: "text-primary underline-offset-4 hover:underline",
        additional: "bg-sahi-primary-color text-white text-base sahi-primary-button py-[6px] px-[10px] sahi-radius",
        semidefault: "bg-sahi-primary-color text-primary-foreground  border border-transparent hover:border-sahi-primary-color",
        noHoversemidefault: "bg-sahi-primary-color text-primary-foreground  border border-transparent ",
        semidefaultcol: "bg-sahi-primary-color text-primary-foreground  border border-transparent",
        iconOnly: "bg-transparent border-none cursor-pointer hover:opacity-60 transition-opacity duration-200 [&_svg]:!size-5 text-sahi-primary-color",
        outlinefiliter: "border sahi-radius border-input bg-background",
      },
      size: {
        default: "h-10 sahi-radius px-2 py-2",
        sm: "h-6 sahi-radius px-2",
        lg: "h-11 sahi-radius px-8",
        icon: "h-8 w-8",
        pgn: "h-9 sahi-radius px-3",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)


const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
